import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TypeCrJugement } from '../models/TypeCrJugement';
import { CriterePondere } from '../models/CriterePondere';
import { Step9 } from '../../../../shared/models/component-messages/mapaIN/step9';
import { MapaINControlNames } from '../service/mapaINControleNames';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { ArrayPopTools } from '../../../../shared/services/array-pop-tools';
import { CTRL_28_2 } from '../../../validators/28/ctrl28_2';
import { CTRL_28_3 } from '../../../validators/28/ctrl28_3';
import { CTRL_1162 } from '../../../validators/1162/ctrl1162';
@Component({
  selector: 'app-type-cr-jugement',
  templateUrl: './type-cr-jugement.component.html'
})
export class TypeCrJugementComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeCrJugement';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() criteres: TypeCrJugement;

  public rg1 = CTRL_1162.id + '_1';
  public rg2 = CTRL_28_2.id + '_1';
  public rg3 = CTRL_28_3.id + '_1';

  public step9 = new Step9();

  radioButtonValue;
  radioButtonCtrlName;
  criterecdc = RadioCheckBoxEnum.criterecdc;
  criterepondere = RadioCheckBoxEnum.criterepondere;
  criterelibre = RadioCheckBoxEnum.criterelibre;
  critereprix = RadioCheckBoxEnum.critereprix;

  constructor() { }

  public ngOnInit() {
  if (!this.criteres) this.criteres = new TypeCrJugement();

  this.radioButtonCtrlName = this.getUid() + '_SepAtt_critereCDC';

  // Par défaut: rien coché
  this.radioButtonValue = null;

  const t = this.criteres.typeCritere;
  const ctrl = this.parentForm?.controls?.[this.radioButtonCtrlName];

  const looksLegacyEmpty =
    t === RadioCheckBoxEnum.emptyValue &&
    this.criteres?.critereCDC == null &&   
    this.criteres?.critereLibre == null &&
    this.criteres?.criterePondere == null &&
    this.criteres?.criterePrix == null;

  if (t === this.criterecdc)        this.radioButtonValue = this.criterecdc;
  else if (t === this.criterepondere) this.radioButtonValue = this.criterepondere;
  else if (t === this.criterelibre)   this.radioButtonValue = this.criterelibre;
  else if (t === this.critereprix)    this.radioButtonValue = this.critereprix;
  else if (looksLegacyEmpty) {
    // Cas vide hérité -> rien coché
    this.radioButtonValue = null;
    if (ctrl && ctrl.value === '') ctrl.setValue(null, { emitEvent: false });
  } else if (t === RadioCheckBoxEnum.emptyValue) {
    // Cas "Aucun critère" VRAIMENT coché et persisté en ''
      this.radioButtonValue = RadioCheckBoxEnum.emptyValue;
    if (ctrl && ctrl.value !== RadioCheckBoxEnum.emptyValue) {
      ctrl.setValue(RadioCheckBoxEnum.emptyValue, { emitEvent: false });
    }
  }
  }

  isCritereLibre(){
    if (this.parentForm.controls[this.getUid() + '_SepAtt_critereCDC']?.value === this.criterelibre) {
      this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_28_2Names_json() }));
      if (this.criteres.critereLibre == null || this.criteres.critereLibre === undefined)
        this.criteres.critereLibre = new Array();
    } else {
      this.criteres.critereLibre = null;
    }
    return this.parentForm.controls[this.getUid() + '_SepAtt_critereCDC']?.value === this.criterelibre;

  }

  isCriterePondere(){
    if (this.parentForm.controls[this.getUid() + '_SepAtt_critereCDC']?.value === this.criterepondere) {
      this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_1162Names_json() }));
      this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_28_1Names_json() }));
      if (this.criteres.criterePondere == null || this.criteres.criterePondere === undefined)
        this.criteres.criterePondere = new Array();
    } else {
      this.criteres.criterePondere = null;
    }
		return this.parentForm.controls[this.getUid() + '_SepAtt_critereCDC']?.value === this.criterepondere;
  }
  
  
  addcriterePondere(){
		this.criteres.criterePondere.push(new CriterePondere());
	}
  
  removecriterePondere(i){
    ArrayPopTools.pop(this.criteres.criterePondere, i, this.parentForm, this.getUid());
	}
  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }
}

